<div class="progressBar_backdrop" [class.progressBar_backdrop--plain]="!showBackdrop">
  <div class="progressBar_root" [class.progressBar_root--compact]="compact">
    <div
      class="progressBar_trackContainer"
      role="progressbar"
      [attr.aria-valuenow]="displayValue"
      aria-valuemin="0"
      aria-valuemax="100">

      <div
        class="progressBar_tooltip"
        [style.inset-inline-start]="thumbInlineStart"
        [style.transform]="tooltipTransform">
        <span class="progressBar_tooltipText">{{ displayValue }}%</span>
        <span class="progressBar_tooltipDot"></span>
      </div>

      <div class="progressBar_trackBg">
        <div
          class="progressBar_trackFill"
          [style.width.%]="displayValue">
        </div>
      </div>

      <div class="progressBar_connectingLine"></div>

      <div class="progressBar_stepsRow">
        <div
          *ngFor="let step of steps"
          class="progressBar_stepMarker"
          [class.progressBar_stepMarker--active]="displayValue >= step.percentage">
          <span>{{ step.label }}</span>
        </div>
      </div>

      <div
        class="progressBar_thumb"
        [style.inset-inline-start]="thumbInlineStart"
        [style.transform]="thumbTransform">
        <div class="progressBar_thumbCircle">
          <svg width="18" height="18" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" class="progressBar_thumbSvg">
            <path
              d="M 33 13 A 14 14 0 1 0 33 29"
              stroke="#111e38"
              stroke-width="7.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle cx="21" cy="21" r="5.5" fill="#ff3c00" />
          </svg>
        </div>
      </div>

    </div>
  </div>
</div>
